import { findIndex, get } from 'lodash';
import {
  getChosenProfileDataAction,
  getChosenProfileRepertoireAction,
  setChosenProfileActiveVideoAction,
  getChosenProfileReviewsAction,
  getChosenProfileProductionsAction,
  getProfileProductionsSeasonsAction,
  getProfileWorksListAction,
  updateProfileInfoAction,
  getChosenProfileBioAction,
  updateBioAction,
  addBioAction,
  getContactsAction,
  updateContactsAction,
  addReviewAction,
  getChosenProfileAgreementsAction,
  updateReviewAction,
  getWishlistRepertoireAction,
  getSearchProductionsAction,
  getArtistProfessions,
  getArtistRoles,
  getProductionCastAction,
  deleteProductionAction,
  getDatesInProductionsAction,
  getArtistProductionsPrivacyAction,
  getArtistImagesAction,
  getArtistBannerImagesAction,
  getArtistMediaAttrTypesAction,
  updateVideoAction,
  addVideoAction,
  getVideoAction,
  getRepertoireProductionListAction,
  updateRepertoireModalAction,
  getRepertoireVideoListAction,
  getRepertoireImageListAction,
  deleteReviewAction,
  getArtistProductionsCountAction,
  removeProductionAction,
  getArtistProductionsAction,
  getArtistVideoFormatAttrTypesAction,
  updateRepertoireAction,
} from './actions';
import {
  defaultListParams,
  listReducer,
  entityReducer,
  defaultEntityParams,
  namedListParams,
} from '../../utils/crudUtils';
import {
  SET_PROFILE,
  CLEAR_PROFILE_WORKS_LIST,
  START_SEARCHING_PROFILE_WORKS_LIST,
  DELETE_BIO,
  DELETE_IMAGE,
  DELETE_VIDEO,
  CLEAN_SEARCH_PRODUCTIONS_LIST,
  REMOVE_REPERTOIRE_RECORD,
} from './constants';

export const key = 'Artist';

export const initialState = {
  profileData: defaultEntityParams,
  profileContacts: defaultListParams,
  artistProductions: defaultListParams,
  repetorieProductions: defaultEntityParams,
  repetorieImages: defaultEntityParams,
  repetorieVideos: defaultEntityParams,
  artistDatesInProductions: defaultListParams,
  searchProductions: defaultListParams,
  repertoire: namedListParams('repertoire'),
  reviews: namedListParams('reviews'),
  activeVideo: {},
  error: null,
  seasons: defaultListParams,
  worksList: defaultListParams,
  worksListStartSearching: false,
  professions: defaultListParams,
  roles: defaultListParams,
  productionCasts: defaultListParams,
  bio: defaultListParams,
  wishlist: namedListParams('wishlist'),
  productionsPrivacyAttributes: namedListParams('productionsPrivacyAttributes'),
  images: namedListParams('images'),
  bannerImages: namedListParams('bannerImages'),
  attributeTypes: namedListParams('attributeTypes'),
  video: namedListParams('video'),
  repertoireModal: false,
  chosenRepetorie: {},
  mediaUpdating: false,
  productions: namedListParams('productions'),
  videoFormats: namedListParams('videoFormats'),
};

const artistReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case getChosenProfileDataAction.TRIGGER:
    case getChosenProfileDataAction.SUCCESS:
    case getChosenProfileDataAction.FAILURE:
      return entityReducer(state, type, payload, 'profileData');
    case SET_PROFILE:
      return { ...state, profileData: payload.profile };

    case getChosenProfileRepertoireAction.TRIGGER:
    case getChosenProfileRepertoireAction.SUCCESS:
    case getChosenProfileRepertoireAction.FAILURE:
      return listReducer(state, type, payload, state?.repertoire?.listName);

    case getChosenProfileReviewsAction.TRIGGER:
    case getChosenProfileReviewsAction.SUCCESS:
    case getChosenProfileReviewsAction.FAILURE:
      return listReducer(state, type, payload, state?.reviews?.listName);

    case getArtistProfessions.TRIGGER:
    case getArtistProfessions.SUCCESS:
    case getArtistProfessions.FAILURE:
      return listReducer(state, type, payload, 'professions');

    case getArtistRoles.TRIGGER:
    case getArtistRoles.SUCCESS:
    case getArtistRoles.FAILURE:
      return listReducer(state, type, payload, 'roles');

    case getProductionCastAction.TRIGGER:
    case getProductionCastAction.SUCCESS:
    case getProductionCastAction.FAILURE:
      return listReducer(state, type, payload, 'productionCasts');

    case setChosenProfileActiveVideoAction.TRIGGER:
      return { ...state, activeVideo: payload };

    case getChosenProfileProductionsAction.FAILURE:
    case getChosenProfileProductionsAction.TRIGGER:
    case getChosenProfileProductionsAction.SUCCESS:
      return listReducer(state, type, payload, 'artistProductions');

    case getRepertoireProductionListAction.FAILURE:
    case getRepertoireProductionListAction.TRIGGER:
    case getRepertoireProductionListAction.SUCCESS:
      return listReducer(state, type, payload, 'repetorieProductions');

    case getRepertoireVideoListAction.FAILURE:
    case getRepertoireVideoListAction.TRIGGER:
    case getRepertoireVideoListAction.SUCCESS:
      return listReducer(state, type, payload, 'repetorieVideos');

    case getRepertoireImageListAction.FAILURE:
    case getRepertoireImageListAction.TRIGGER:
    case getRepertoireImageListAction.SUCCESS:
      return listReducer(state, type, payload, 'repetorieImages');

    case getSearchProductionsAction.FAILURE:
    case getSearchProductionsAction.TRIGGER:
    case getSearchProductionsAction.SUCCESS:
      return listReducer(state, type, payload, 'searchProductions');

    case updateProfileInfoAction.TRIGGER:
    case updateProfileInfoAction.FAILURE:
    case updateProfileInfoAction.SUCCESS:
      return entityReducer(state, type, payload, 'profileData');

    case getChosenProfileBioAction.TRIGGER:
    case getChosenProfileBioAction.FAILURE:
    case getChosenProfileBioAction.SUCCESS:
      return listReducer(state, type, payload, 'bio');

    case getContactsAction.TRIGGER:
    case getContactsAction.FAILURE:
    case getContactsAction.SUCCESS:
      return entityReducer(
        state,
        type,
        payload.data ? { ...payload, data: payload.data.map(el => ({ ...el, name: el.name.toLowerCase() })) } : payload,
        'profileContacts',
      );

    case updateContactsAction.SUCCESS:
      return { ...state, profileContacts: { ...state.profileContacts, data: payload?.entity?.contacts } };

    case updateBioAction.SUCCESS: {
      const bios = [...(state?.bio?.data || [])];
      const updatedBioIndex = findIndex(state?.bio?.data || [], { id: payload?.entity?.id });
      bios.splice(updatedBioIndex, 1, payload?.entity);
      return { ...state, bio: { ...state.bio, data: bios } };
    }

    case addBioAction.SUCCESS: {
      const bios = [...(state?.bio?.data || []), payload?.entity];
      return { ...state, bio: { ...state.bio, data: bios } };
    }

    case DELETE_BIO: {
      const bios = [...(state?.bio?.data || [])].filter(b => b?.id !== payload?.id);
      return { ...state, bio: { ...state.bio, data: bios } };
    }

    case getChosenProfileAgreementsAction.FAILURE:
    case getChosenProfileAgreementsAction.TRIGGER:
    case getChosenProfileAgreementsAction.SUCCESS:
      return listReducer(state, type, payload, 'artistAgreements');

    case addReviewAction.TRIGGER:
      return { ...state, mediaUpdating: true };
    case addReviewAction.FAILURE:
      return { ...state, mediaUpdating: false };
    case addReviewAction.SUCCESS: {
      const reviews = [...state?.reviews?.data, payload?.entity];
      return { ...state, reviews: { ...state.reviews, data: reviews }, mediaUpdating: false };
    }

    case updateReviewAction.TRIGGER:
      return { ...state, mediaUpdating: true };
    case updateReviewAction.FAILURE:
      return { ...state, mediaUpdating: false };
    case updateReviewAction.SUCCESS: {
      const reviews = [...state?.reviews?.data];
      const updatedReviewIndex = findIndex(state?.reviews?.data, { id: payload?.entity?.id });
      reviews.splice(updatedReviewIndex, 1, payload?.entity);
      return { ...state, reviews: { ...state.reviews, data: reviews }, mediaUpdating: false };
    }
    case getWishlistRepertoireAction.TRIGGER:
    case getWishlistRepertoireAction.SUCCESS:
    case getWishlistRepertoireAction.FAILURE:
      return listReducer(state, type, payload, initialState.wishlist.listName);

    case getProfileProductionsSeasonsAction.FAILURE:
    case getProfileProductionsSeasonsAction.TRIGGER:
    case getProfileProductionsSeasonsAction.SUCCESS:
      return listReducer(state, type, payload, 'seasons');

    case getDatesInProductionsAction.FAILURE:
    case getDatesInProductionsAction.TRIGGER:
    case getDatesInProductionsAction.SUCCESS:
      return listReducer(state, type, payload, 'artistDatesInProductions');

    case getProfileWorksListAction.FAILURE:
    case getProfileWorksListAction.TRIGGER:
    case getProfileWorksListAction.SUCCESS:
      return { ...listReducer(state, type, payload, 'worksList'), worksListStartSearching: false };

    case CLEAR_PROFILE_WORKS_LIST:
      return { ...state, worksList: { ...state.worksList, data: [] } };

    case START_SEARCHING_PROFILE_WORKS_LIST:
      return { ...state, worksListStartSearching: true };

    case DELETE_IMAGE:
      return {
        ...state,
        images: { ...state.images, data: state.images.data.filter(i => i?.id !== payload?.id) },
        bannerImages: { ...state.bannerImages, data: state.bannerImages.data.filter(bI => bI?.id !== payload?.id) },
      };
    case DELETE_VIDEO:
      return { ...state, video: { ...state.video, data: state.video.data.filter(i => i?.id !== payload?.id) } };

    case deleteProductionAction.SUCCESS:
      return {
        ...state,
        artistProductions: {
          ...state.artistProductions,
          data: get(state, 'artistProductions.data', []).filter(p => p?.id !== payload.id),
        },
      };
    case deleteProductionAction.FAILURE:
      return { ...state, error: payload };

    case getArtistProductionsPrivacyAction.TRIGGER:
    case getArtistProductionsPrivacyAction.SUCCESS:
    case getArtistProductionsPrivacyAction.FAILURE:
      return entityReducer(state, type, payload, initialState.productionsPrivacyAttributes.listName);

    case getArtistImagesAction.FAILURE:
    case getArtistImagesAction.TRIGGER:
    case getArtistImagesAction.SUCCESS:
      return listReducer(state, type, payload, initialState.images.listName);

    case getArtistBannerImagesAction.FAILURE:
    case getArtistBannerImagesAction.TRIGGER:
    case getArtistBannerImagesAction.SUCCESS:
      return listReducer(state, type, payload, initialState.bannerImages.listName);

    case getArtistMediaAttrTypesAction.FAILURE:
    case getArtistMediaAttrTypesAction.TRIGGER:
    case getArtistMediaAttrTypesAction.SUCCESS:
      return listReducer(state, type, payload, initialState.attributeTypes.listName);

    case deleteReviewAction.TRIGGER:
      return { ...state, mediaUpdating: true };
    case deleteReviewAction.SUCCESS: {
      return {
        ...state,
        reviews: { ...state.reviews, data: state.reviews.data.filter(r => r?.id !== payload?.id) },
        mediaUpdating: false,
      };
    }
    case deleteReviewAction.FAILURE:
      return { ...state, mediaUpdating: false };

    case getVideoAction.FAILURE:
    case getVideoAction.TRIGGER:
    case getVideoAction.SUCCESS:
      return listReducer(state, type, payload, initialState.video.listName);

    case getArtistProductionsCountAction.FAILURE:
    case getArtistProductionsCountAction.TRIGGER:
    case getArtistProductionsCountAction.SUCCESS:
      return listReducer(state, type, payload, 'artistProductions');

    case updateVideoAction.TRIGGER:
      return { ...state, mediaUpdating: true };
    case updateVideoAction.SUCCESS: {
      const video = [...state?.video?.data];
      const updatedReviewIndex = findIndex(state?.video?.data, { id: payload?.entity?.id });
      video.splice(updatedReviewIndex, 1, payload?.entity);
      return { ...state, video: { ...state.video, data: video }, mediaUpdating: false };
    }
    case updateVideoAction.FAILURE:
      return { ...state, mediaUpdating: false };

    case addVideoAction.TRIGGER:
      return { ...state, mediaUpdating: true };
    case addVideoAction.SUCCESS: {
      return {
        ...state,
        video: { ...state.video, data: [...state.video.data, payload?.entity] },
        mediaUpdating: false,
      };
    }
    case addVideoAction.FAILURE:
      return { ...state, mediaUpdating: false };

    case updateRepertoireModalAction.SUCCESS: {
      return {
        ...state,
        repertoireModal: payload?.flag,
        chosenRepetorie: payload?.rep || {},
        repetorieProductions: defaultEntityParams,
        repetorieImages: defaultEntityParams,
        repetorieVideos: defaultEntityParams,
      };
    }

    case CLEAN_SEARCH_PRODUCTIONS_LIST:
      return { ...state, searchProductions: defaultListParams };

    case removeProductionAction.TRIGGER:
      return {
        ...state,
        artistProductions: {
          ...state.artistProductions,
          privacyLoading: payload.productionId,
        },
      };
    case removeProductionAction.SUCCESS:
    case removeProductionAction.FAILURE:
      return {
        ...state,
        artistProductions: {
          ...state.artistProductions,
          data: state.artistProductions.data.filter(el => el.id !== payload.entity?.production?.id),
          privacyLoading: null,
        },
      };

    case REMOVE_REPERTOIRE_RECORD:
      return {
        ...state,
        repertoire: { ...state.repertoire, data: state.repertoire?.data?.filter(record => record?.id !== payload?.id) },
      };

    case getArtistProductionsAction.FAILURE:
    case getArtistProductionsAction.TRIGGER:
    case getArtistProductionsAction.SUCCESS:
      return listReducer(state, type, payload, 'productions');

    case getArtistVideoFormatAttrTypesAction.FAILURE:
    case getArtistVideoFormatAttrTypesAction.TRIGGER:
    case getArtistVideoFormatAttrTypesAction.SUCCESS:
      return listReducer(state, type, payload, state.videoFormats.listName);

    case updateRepertoireAction.SUCCESS: {
      const repertoireIndex = state.repertoire.data.findIndex(el => el.id === payload.entity.id);
      return {
        ...state,
        repertoire: {
          ...state.repertoire,
          data: Object.assign([], state.repertoire.data, { [repertoireIndex]: payload.entity }),
        },
      };
    }

    default:
      return state;
  }
};

export default artistReducer;
